module.exports = __webpack_public_path__ + "static/media/zenodo-connect.62ea78bf.png";